// extracted by mini-css-extract-plugin
export default {"header":"Header_header__1ZNqg","svg":"Header_svg__FNFZL"};